import script from "./index.vue?vue&type=script&lang=ts&name=UserIndex&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&name=UserIndex&setup=true"

import "./index.vue?vue&type=style&index=0&id=0e8910ff&lang=scss&scoped=true"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8910ff"]])

export default __exports__